module.exports = __webpack_public_path__ + "static/media/TERRASSE_ET_JARDIN_COMMUNS_(7).43b6d78f.jpg";